import { appEnv } from "../model/Common";

/**
 * Webタイトル.
 *
 * @type {string}
 */
const appTitle = "HFMAPS　A/S支援システム";

export const webTitle = (() => {
  switch (process.env.REACT_APP_ENV) {
    case appEnv.dev:
      return `${appTitle}(開発環境 <最終更新日時: ${process.env.REACT_APP_BUILD_DATE}>)`;
    case appEnv.stgsecond:
      return `${appTitle}(検証環境 <最終更新日時: ${process.env.REACT_APP_BUILD_DATE}>)`;
    case appEnv.prodsecond:
      return appTitle;
    default:
      return `${appTitle}(${process.env.REACT_APP_ENV} <最終更新日時: ${process.env.REACT_APP_BUILD_DATE}>)`;
  }
})();

/**
 * Storeキー名.
 *
 * @type {object}
 */
export const storeKeyName = {
  dashboard: "DashboardStore",
  file: "FileStore",
  office: "OfficeStore",
  report: "ReportStore",
  auth: "AuthStore",
  remoteMaintenance: "RemoteMaintenanceStore",
  dataGraph: "DataGraphStore",
  register: "RegisterStore",
  referenceLine: "ReferenceLineStore",
};

/**
 * ファイル種別.
 *
 * @type {object}
 */
export const fileType = {
  file: "FILE",
  folder: "FOLDER",
};

/**
 * Cognitグループ.
 *
 * @type {object}
 */
export const cognitoGroup = {
  file: "00_file",
  fileRead: "00_file-read",
  fileWrite: "00_file-write",
  dashboard: "00_dashboard",
  admin: "20_admin",
  serviceMan: "30_serviceman",
};

/**
 * エラー種別.
 *
 * @type {object}
 */
export const errorType = {
  systemError: "SYSTEM ERROR",
  networkError: "NETWORK ERROR",
  authError: "AUTH ERROR",
  lambdaTmpSizeOver: "LAMBDA TMP SIZE OVER",
  s3PollingTimeout: "S3 POLLING TIMEOUT",
};

/**
 * エラーメッセージ.
 *
 * @type {object}
 */
export const errorMessage = {
  systemError:
    "システムエラーが発生しました。しばらく時間をおいてから再度お試しください。\nまた、改善されない場合はシステム管理者にお問い合わせください。",
  networkError:
    "通信エラーが発生しました。通信環境をご確認のうえ、再度お試しください。",
  authError: "認証エラーが発生しました。再度サインインしてください。",
};
